<template>
  <div class="contactmap">
    <div class="body">
      <div class="left">
        <div class="title">联系我们</div>
        <div class="item" v-for="item in contactmapList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div style="display: flex">
            <div>{{ item.label }}</div>
            <div>
              <div v-for="(it, index) in item.title" :key="index">{{ it }}</div>
            </div>
          </div>
        </div>
        <div class="contact_list">
          <div class="contact_item" v-for="item in contactList" :key="item.id">
            <img :src="item.img" alt="" />
            <div>{{ item.text }}</div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>

      <div class="right">
        <div id="map" ref="mapRef"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted } from "vue";

import contactmapLogo1 from "../../../assets/contact/contactmapLogo1.png";
// import contactmapLogo2 from "../../../assets/contact/contactmapLogo2.png";
import contactmapLogo3 from "../../../assets/contact/contactmapLogo3.png";
import contactmapLogo4 from "../../../assets/contact/contactmapLogo4.png";

import contactImg1 from "../../../assets/contact/contactImg1.png";
import contactImg2 from "../../../assets/contact/contactImg2.png";

onMounted(() => {
  nextTick(() => {
    initMap();
  });
});
const initMap = () => {
  // const mapRef = ref(null)
  const aimap = window.aimap;
  const center = [121.40762975591736, 31.422375007666005];
  const wzMap = new aimap.Map({
    accessToken: "MGDsHGaDgcossaIoTmqTJPyNwo36uUFv",
    container: "map",
    center: center,
    zoom: 16,
    // 地图倾斜角度
    pitch: 20,
    // 地图旋转角度
    bearing: 0,
    // 地图样式
    style: "aimap://styles/aimap/normal-v4"
  });
  new aimap.Popup({ closeOnClick: false })
    .setLngLat(center)
    .setHTML(
      `<div class="popup-bg">
    <p class="popup-text" style="font-size: 14px; font-weight: bold; margin-bottom: 12px;">上海畅月物业管理有限公司</p>
    <p class="popup-text" style="font-size: 12px; margin-bottom: 8px;">电话：021-6111-9222</p>
    <p class="popup-text" style="font-size: 12px; margin: 0;">地址：上海市宝山区川巷路88-2</p>
</div>`
    )
    .addTo(wzMap);
};
const contactmapList = [
  {
    id: 1,
    title: ["何女士"],
    logo: contactmapLogo1,
    label: "联系人："
  },
  {
    id: 3,
    title: ["021-6111-9222"],
    logo: contactmapLogo3,
    label: "服务热线："
  },
  {
    id: 2,
    title: ["181-2107-8988", "132-9612-5222"],
    logo: contactmapLogo3,
    label: "服务电话："
  },
  {
    id: 4,
    title: ["上海市宝山区川巷路88-2"],
    logo: contactmapLogo4,
    label: "地址："
  }
];
const contactList = [
  {
    id: 1,
    img: contactImg1,
    title: "领取体验账号",
    text: "添加微信"
  },
  {
    id: 2,
    img: contactImg2,
    title: "了解更多",
    text: "关注公众号"
  }
];
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .contactmap {
    min-width: 1180px;
  }
}
.contactmap {
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  padding: 60px 0;
  margin-top: 80px;
}
.body {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.body .left .title {
  font-size: 24px;
  color: #2a3d50;
}
.body .left .item {
  display: flex;
  align-items: center;
  margin-top: 40px;
}
.body .left .item img {
  width: 28px;
  margin-right: 20px;
}
.body .left .item div {
  font-size: 16px;
  color: #2a3d50;
}
#map {
  width: 800px;
  height: 100%;
}
.contact_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
}
.contact_item {
  margin: 0 10px;
  text-align: center;
}
.contact_item img {
  width: 133px;
}
.contact_item div:nth-of-type(1) {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 6px;
}
.contact_item div:nth-of-type(2) {
  font-size: 16px;
  color: #333333;
  margin-top: 4px;
}
</style>
